import { TEMPLATE_SHOPIFY } from '~/constants/template';
import { ProviderSource } from '~/types/template';

export const isTemplateShopify = (providerSource?: ProviderSource): boolean => {
  if (!providerSource) return false;

  return TEMPLATE_SHOPIFY.includes(providerSource);
};

export const isTemplateShopifyOrigin = (providerSource?: ProviderSource): boolean => {
  if (!providerSource) return false;

  return providerSource === ProviderSource.SHOPIFY_ORIGIN;
};

export const isTemplateShopifyBackup = (providerSource?: ProviderSource): boolean => {
  if (!providerSource) return false;

  return providerSource === ProviderSource.SHOPIFY_GP_BACKUP;
};

export const isTemplateGP = (providerSource?: ProviderSource): boolean => {
  if (!providerSource) return false;

  return (
    providerSource === ProviderSource.GEMPAGESV6 || providerSource === ProviderSource.GEMPAGESV7
  );
};
